import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePost } from '../services/postService';
import { logger } from '../utils/logger';

interface UpdatePostResponse {
  success: boolean;
  data?: any;
  message?: string;
}

export const useUpdatePost = () => {
  const queryClient = useQueryClient();
  
  return useMutation<UpdatePostResponse, Error, { postId: string; postData: any; isFormData?: boolean }>({
    mutationFn: async ({ postId, postData, isFormData = false }): Promise<UpdatePostResponse> => {
      try {
        logger.info('useUpdatePost', `Updating post ID: ${postId}`);
        const result = await updatePost(postId, postData, isFormData);
        
        logger.info('useUpdatePost', 'Post updated successfully');
        return {
          success: true,
          data: result
        };
      } catch (error) {
        logger.error('useUpdatePost', 'Error updating post:', error);
        throw error;
      }
    },
    onSuccess: () => {
      // Invalidate the posts query to refetch the list
      queryClient.invalidateQueries({ queryKey: ['posts'] });
      logger.info('useUpdatePost', 'Posts queries invalidated');
    }
  });
}; 